<template>
    <app-layout title="Gebruikers">
        <template #header>
            <page-title :title="'Gebruikers - ' + user_info.name" />
        </template>

        <template #pageContent>

        <div class="text-center">
            <Button
                htmlType="a"
                buttonClass="edit"
                title="Gebruiker wijzigen"
                text="Gebruiker wijzigen"
                :href="route('admin.users.edit', {'id':user_info.id})"
            />
            <Button
                buttonClass="block"
                title="Gebruiker blokkeren"
                text="Gebruiker blokkeren"
                @click="blockUser"
                v-if="user_info.status == 'active'"
            />
            <Button
                buttonClass="approve"
                title="Gebruiker activeren"
                text="Gebruiker activeren"
                @click="activateUser(true)"
                v-else-if="user_info.status == 'pending'"
            />
            <Button
                buttonClass="approve"
                title="Gebruiker deblokkeren"
                text="Gebruiker deblokkeren"
                @click="activateUser(false)"
                v-else
            />
            <Button
                buttonClass="delete"
                title="Gebruiker verwijderen"
                text="Gebruiker verwijderen"
                @click="deleteUser"
            />
            <Button
                htmlType="a"
                buttonClass="login"
                title="Gebruiker overnemen"
                text="Gebruiker overnemen"
                :href="route('impersonate', {'id': user_info.id })"
                v-if="user_info.status == 'active'"
            />
            <Button
                htmlType="a"
                buttonClass="send"
                title="Welkom mail versturen"
                text="Welkom mail versturen"
                :href="route('admin.users.welcome', {'id':user_info.id})"
                v-if="user_info.status == 'active'"
            />
        </div>
        <div id="info" class="border-solid border border-slate-300 rounded m-4">
            <div class="border-solid border-b border-slate-300 bg-gray-100">
                <p class="pt-2 pl-2">Algemene informatie</p>
            </div>
            <div class="mt-1">
                <div>
                    <p class="text-center text-2xl mt-4 font-bold">{{ user_info.name }}</p>
                    <p class="text-center"><a :href="'mailto:' + user_info.email">{{ user_info.email }}</a></p>
                </div>
                <div class="m-4">
                    <div class="flex">
                        <p class="w-1/4 text-left font-bold">Gebruiker ID</p>
                        <p class="w-3/4 text-left">{{ user_info.id }}</p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">Gebruikersnaam</p>
                        <p class="w-3/4 text-left">{{ user_info.username }}</p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">Persoonsnaam</p>
                        <p class="w-3/4 text-left">{{ user_info.name }}</p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">E-mail</p>
                        <p class="w-3/4 text-left">{{ user_info.email }}</p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">Functie</p>
                        <p class="w-3/4 text-left">{{ user_info.function }}</p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">Opmerking</p>
                        <pre class="w-3/4 text-left">{{ user_info.comment }}</pre>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">Status</p>
                        <p class="w-3/4 text-left">
                            <badge :text="user_info.status" v-if="user_info.status == 'active'" class="text-base"/>
                            <badge :text="user_info.status" v-else-if="user_info.status == 'pending'" badgeClass="warning" class="text-base"/>
                            <badge :text="user_info.status" v-else-if="user_info.status == 'blocked'" badgeClass="dark" class="text-base"/>
                            <badge :text="user_info.status" v-else badgeClass="danger" class="text-base"/>
                        </p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">In dienst op</p>
                        <p class="w-3/4 text-left">{{ user_info.activate_on }}</p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">Uit dienst op</p>
                        <p class="w-3/4 text-left">{{ user_info.deactivate_on }}</p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">Aangemaakt op</p>
                        <p class="w-3/4 text-left">{{ moment(user_info.created_at).format('DD/MM/YYYY HH:mm') }}</p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">Gewijzigd op</p>
                        <p class="w-3/4 text-left">{{ moment(user_info.updated_at).format('DD/MM/YYYY HH:mm') }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div id="roles" class="border-solid border border-slate-300 rounded m-4">
            <div class="border-solid border-b border-slate-300 bg-gray-100">
                <p class="pt-2 pl-2">Rollen en Rechten</p>
            </div>
            <div class="m-4">
                <div class="flex">
                    <p class="w-1/4 font-bold">Rollen</p>
                    <div class="w-3/4">
                        <template v-for="role in user_info.roles">
                            <badge :text="role.name" v-if="role.slug == 'admin'" badgeClass="danger" class="text-sm"/>
                            <badge :text="role.name" v-else-if="role.slug == 'it'" badgeClass="warning" class="text-sm"/>
                            <badge :text="role.name" v-else-if="role.level > 0" badgeClass="dark" class="text-sm"/>
                            <badge :text="role.name" v-else badgeClass="light" class="sm"/>
                        </template>
                    </div>
                </div>
                <div class="flex border-t pt-1">
                    <p class="w-1/4 font-bold">Rechten</p>
                    <div class="w-3/4">
                        <badge v-for="permission in user_info.user_permissions" :text="permission.name" badgeClass="dark" class="text-sm"/>
                    </div>
                </div>
                <div class="flex border-t pt-1">
                    <p class="w-1/4 font-bold">Toegangsniveaus</p>
                    <div class="w-3/4">
                        <template v-for="(level,key) in levels">
                            <badge :text="key + ': ' + level" v-if="key == 'admin'" badgeClass="danger" class="text-sm"/>
                            <badge :text="key + ': ' + level" v-else-if="key == 'it'" badgeClass="warning" class="text-sm"/>
                            <badge :text="key + ': ' + level" v-else-if="level > 0" badgeClass="dark" class="text-sm"/>
                            <badge :text="key + ': ' + level" v-else badgeClass="light" class="text-sm"/>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div id="tokens" class="border-solid border border-slate-300 rounded m-4" v-if="this.$page.props.user.roles.includes('admin')">
            <div class="border-solid border-b border-slate-300 bg-gray-100 flex" >
                <p class="pt-2 pl-2">Tokens</p>
            </div>
            <div class="m-4">
                <Button
                    htmlType="a"
                    buttonClass="add"
                    title="Token toevoegen"
                    text="Token toevoegen"
                    :href="route('admin.users.tokens.create', {'user': user_info.id})"
                />
                <div class="border-t pt-1" v-for="token in user_info.tokens">
                    <Button
                        buttonClass="delete"
                        title="Token verwijderen"
                        size="small"
                        class="float-right ml-1"
                        @click="deleteToken(token)"
                    />
                    <Button
                        htmlType="a"
                        buttonClass="edit"
                        title="Token wijzigen"
                        size="small"
                        class="float-right ml-1"
                        :href="route('admin.users.tokens.edit', {'token':token.id, 'user': user_info.id})"
                    />
                    <badge :text="'laatst gebruikt : ' + moment(token.last_used_at).format('DD/MM/YYYY HH:mm')" class="float-right text-sm" v-if="token.last_used_at" badgeClass="light"></badge>
                    <p>Naam: {{ token.name }}</p>
                </div>
            </div>
        </div>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Td from '@/Components/Td.vue'
import Th from '@/Components/Th.vue'
import Button from '@/Components/Button.vue'
import Modal from '@/Components/Modal.vue'
import Input from '@/Components/Input.vue'
import Badge from '@/Components/Badge.vue'
import Select from '@/Components/Select.vue'
import Form from '@/Components/Form.vue'

import { Link } from '@inertiajs/inertia-vue3';
import store from '@/store'
import moment from "moment";
import { Inertia } from "@inertiajs/inertia"

export default {
    components: {
        AppLayout,
        PageTitle,
        Link, Table,
        Td,
        Th,
        Button,
        Modal,
        Input,
        Badge,
        Select,
        Form
    },
    props:[
        'user_info'
    ],
    data() {
        return {}
    },
    setup (props){
        function deleteUser(){
            if(confirm('Gebruiker \'' + props.user_info.name + '\' wissen?')){
                Inertia.delete('/admin/users/' + props.user_info.id)
            }
        }
        function blockUser(){
            Inertia.put('/admin/users/' + props.user_info.id + '/status', {'status':'blocked', 'mail': false})
        }
        function activateUser(mail){
            mail = mail ? 'ja' : 'nee';
            mail = prompt('Wil je een welkommail sturen? (ja/nee)', mail);
            Inertia.put('/admin/users/' + props.user_info.id + '/status', {'status':'active', 'mail': mail == 'ja'})
        }
        function deleteToken(token){
            if(confirm('Token \'' + token.name + '\' wissen?')){
                Inertia.delete('/admin/users/' + props.user_info.id + '/tokens/' + token.id)
            }
        }
        return {
            state: store.state,
            ...store,
            deleteUser,
            blockUser,
            activateUser,
            deleteToken
        }
    },
    created: function () {
        this.moment = moment;
    },
    computed: {
        levels(){
            let temp = {}
            this.user_info.roles.forEach(function (role){
                if(role.departments.length > 0){
                    role.departments.forEach(function (department){
                        if(temp.hasOwnProperty(department.department)){
                            if(temp.hasOwnProperty(department.department) < role.level) temp[department.department] = role.level
                        }else{
                            temp[department.department] = role.level
                        }
                    })
                }else{
                    let department = 'algemeen'
                    if(temp.hasOwnProperty(department)){
                        if(temp.hasOwnProperty(department) < role.level) temp[department] = role.level
                    }else{
                        temp[department] = role.level
                    }
                }

            })
            return temp
        }
    },
}

</script>
